import { parseMarkdownCell } from "@/components/markdown/parse-cell";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export const renderMarkdownTable = (rows: string[][]) => {
  if (rows.length === 0) return null;

  const [headerRow, ...bodyRows] = rows;
  if (!headerRow) return null;

  return (
    <Table className="rounded-lg text-base [&>*]:text-brand-green1-500">
      <TableHeader>
        <TableRow>
          {headerRow.map((cell, index) => (
            <TableHead className="p-2 font-medium text-lg" key={index}>
              {parseMarkdownCell(cell)}
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {bodyRows.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            {row.map((cell, cellIndex) => (
              <TableCell key={cellIndex}>{parseMarkdownCell(cell)}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export const extractTextFromChildren = (
  children: React.ReactNode
): string | null => {
  if (typeof children === "string") return children;
  if (typeof children === "number") return String(children);

  if (Array.isArray(children)) {
    return children
      .map((child) => extractTextFromChildren(child))
      .filter((text): text is string => text !== null)
      .join("\n");
  }

  if (
    children &&
    typeof children === "object" &&
    "props" in children &&
    children.props &&
    typeof children.props === "object"
  ) {
    const props = children.props as Record<string, unknown>;
    if (typeof props.text === "string") {
      return props.text;
    }
    if ("children" in props) {
      return extractTextFromChildren(props.children as React.ReactNode);
    }
  }

  return null;
};
